/* eslint-disable curly */
import React, { Component, useState, useRef } from "react";
import {
  View,
  Text,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  Image,
  Dimensions,
} from "react-native";

import { getStatusPorCpf } from "../../../services/aluno-service";
import ButtonConfirm from "../../../components/ButtonConfirm";
import Loading from "../../../components/Loading";
import styles from "./styles";
import { TextInputMask } from "react-native-masked-text";
import logo from "../../../../assets/logo_space.png";
import { alert } from "../../../utils/alerts";

const Login = ({ navigation }) => {
  const [cpf, setCpf] = useState("");
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  // StatusBar.setBarStyle("light-content");

  const inputCpf = useRef();

  // navigation.addListener("didFocus", (payload) => {
  //   StatusBar.setBackgroundColor("#F00");
  // });

  const buscar = async (e) => {
    if (!inputCpf.current.isValid()) return;

    try {
      setLoading(true);
      const unmaskedCpf = inputCpf.current.getRawValue();

      const response = await getStatusPorCpf(unmaskedCpf);
      if (response.status === 404) {
        setLoading(false);

        return alert(
          "Não cadastrado",
          "Você ainda não está na nossa base de dados, fale com o seu professor!"
        );
      }

      if (response.status === 500) {
        setLoading(false);

        return alert("Falha", "Erro ao buscar, tente novamente mais tarde!");
      }

      let aluno = await response.json();

      setLoading(false);

      if (!aluno.ativo)
        return navigation.navigate("TermoDeUso", {
          aluno: aluno,
        });

      return navigation.navigate("ValidarSenha", { aluno: aluno });
    } catch (e) {
      setLoading(false);

      console.log(e);
    }
  };

  const handlerCpf = async (e) => {
    await setCpf(e);
    if (e.length === 14) {
      if (!inputCpf.current.isValid()) {
        return alert("Cpf inválido");
      } else {
        return setConfirmDisabled(false);
      }
    }
    setConfirmDisabled(true);
  };

  return (
    <>
      {loading && <Loading />}
      <ImageBackground
        source={require("../../../../resources/imgs/bg.jpg")}
        style={[styles.container]}
        imageStyle={styles.imageContainer}
      >
        <View style={[styles.containerForm, { paddingTop: 0 }]}>
          <View style={{ marginTop: 40, zIndex: 0 }}>
            <Image
              style={{
                width: Dimensions.get("window").width / 1.5,
                height: Dimensions.get("window").width / 2.22,
                maxWidth: 400,
                maxHeight: 200,
                resizeMode: "contain",
                zIndex: 0,
              }}
              source={logo}
            />
          </View>
          <KeyboardAvoidingView
            keyboardVerticalOffset={Platform.OS === "ios" ? "0" : "50"}
            behavior={Platform.OS === "ios" ? "padding" : "position"}
            enabled
          >
            <Text
              style={[
                styles.textHeader1,
                {
                  fontSize:
                    Dimensions.get("window").width > 768
                      ? 45
                      : Dimensions.get("window").width / 15,
                  textShadowColor: "black",
                  textShadowOffset: { width: 2, height: 2 },
                  textShadowRadius: 5,
                },
              ]}
            >
              O BANCO DE TALENTOS DA INDÚSTRIA BRASILEIRA
            </Text>
            <Text style={[styles.textHeader2]}>
              Informe seu cpf para começarmos:
            </Text>
            <TextInputMask
              type="cpf"
              style={[
                styles.input,
                { textAlign: "center", alignSelf: "center" },
              ]}
              ref={inputCpf}
              placeholder="CPF do aluno"
              keyboardType="phone-pad"
              placeholderTextColor="#ccc"
              KeyboardAvoidingView={true}
              value={cpf}
              onChangeText={handlerCpf}
              onSubmitEditing={() => {
                buscar();
              }}
            />
          </KeyboardAvoidingView>
          <ButtonConfirm
            text="Vamos lá!"
            disabled={confirmDisabled}
            onPress={buscar}
            msgDisabled="Por favor, preencha com um CPF válido"
          />
        </View>
      </ImageBackground>
    </>
  );
};

export default Login;
